import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule,ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { ICD10Component } from './icd10.component';
import { NumericTextBoxModule, NumericTextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { NgxUiLoaderModule,  } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { Icd10RoutingModule } from './icd10-routing.module';
@NgModule({
  declarations: [
    ICD10Component,
  ],
  exports:[ICD10Component],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    Icd10RoutingModule
  ],
  providers: [ColumnChooserService,PageService,SortService,FilterService,ResizeService],
})
export class ICD10Module { }
